module.exports = __webpack_public_path__ + "media/images/lp/1/achievement3-pc-42f852f2a1cbaadf06649e120a635e8c.png";